import React, { FC, useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

import { Slider } from 'application/components';
import { useAppDispatch, useAppSelector } from 'application/store';
import { getDealFile } from 'application/store/Deal/actions';
import { setFile } from 'application/store/PreviewerPDF/previewerPDFSlice';
import { PathNames } from 'application/routes';
import { AmplitudeEvent, useAmplitude } from 'application/hooks/useAmplitude';
import { requestSelector } from 'application/store/request/selectors';

import { Container, Title, Wrapper } from './styles';

const PitchDeck: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { deal } = useAppSelector((state) => state.deal);
  const { loading } = useAppSelector(requestSelector).getDealFile;
  const { trackEvent } = useAmplitude();

  const [files, setFiles] = useState<Blob[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (deal?.id && deal?.overview.pitchDecks.length) {
      const getFiles = async () => {
        setIsLoading(true);
        const filesList = await Promise.all(
          deal?.overview.pitchDecks.map(async (file) => {
            const response = await dispatch(
              getDealFile({
                id: deal.id,
                fileId: file.id,
              })
            );
            const data = response.payload as Blob;
            const fileBlob = new Blob([data], {
              type: data.type as string,
            });
            return fileBlob;
          })
        );
        setIsLoading(false);
        setFiles(filesList);
      };
      getFiles();
    }
  }, [deal?.overview.pitchDecks, deal?.id]);

  const onPreview = (file: Blob) => {
    dispatch(setFile(file));
    navigate(PathNames.previewerPDF);
    trackEvent(AmplitudeEvent.Deals_Overview_Pitch, {
      deal_title: deal?.title,
    });
  };

  return (
    <Wrapper>
      <Title>Pitch deck</Title>
      <Container>
        {(loading || isLoading) && <CircularProgress />}
        {!!files.length && (
          <Slider>
            {files.map((file, index) => (
              <Document
                key={`document-${index + 1}`}
                file={file}
                className={'pdf-document'}
                onClick={() => onPreview(file)}
                externalLinkRel={'noreferrer'}
                externalLinkTarget={'_blank'}
              >
                <Page
                  pageNumber={1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              </Document>
            ))}
          </Slider>
        )}
      </Container>
    </Wrapper>
  );
};

export default PitchDeck;
